import { useCallback } from 'react';
import { showErrorDialog } from 'v3/data/store/error/actions';
import { setPaymentDetails } from 'v3/data/store/onlineContracting/actions';
import * as onlineApi from 'v3/services/online/api';

export const useFetchContractingDetails = () => {
  const fetchContractingDetails = useCallback(async (contractingKey: string) => {
    try {
      const response = await onlineApi.getPaymentDetails(contractingKey);
      setPaymentDetails(response.data);
    } catch (error) {
      showErrorDialog('Erro ao obter detalhes do pagamento');
      throw error;
    }
  }, []);

  return { fetchContractingDetails };
};
